export enum StudyDesignOptions {
  default = '',
  yes = 'yes',
  no = 'no',
}
